import HttpStatus from 'http-status-codes'
import HTTP from '@/utils/http'
import notification from '@/utils/notification'
import store from '@/store'

export function getFloorIndex (buildingCode, floor) {
  const allBuildings = store.getters['buildings/allBuildings']
  const currentBuildingInfo = allBuildings.find(item => item.code === buildingCode) || {}
  const currentBuildingFloors = currentBuildingInfo.floor || []
  if (currentBuildingFloors.includes(floor)) {
    return currentBuildingFloors.indexOf(floor)
  }
  return Number.MAX_SAFE_INTEGER
}

export async function getBuildings (queryParams) {
  try {
    const response = await HTTP.get('buildings', { params: queryParams })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return []
  }
}

export async function getBuildingFloorZoneMap () {
  const Buildings = []
  const Sites = {}
  const Zones = []
  const BuildingFloorZoneMap = {}

  const response = await HTTP.get('buildings')
  const buildings = response.data.data

  if (Array.isArray(buildings)) {
    buildings.forEach(building => {
      const sites = building.sites || []

      // site is no longer to use since one building can belongs to multi site. Consider to remove in future
      const siteCode = building.site && building.site.code
      if (building.code) {
        Buildings.push(building.code)
        const zones = building.zones
        zones.forEach(zone => {
          if (!Zones.includes(zone)) {
            Zones.push(zone)
          }
        })
        BuildingFloorZoneMap[building.code] = {
          id: building.id,
          building: building.code,
          code: building.code,
          floor: building.floor,
          commonFloor: building.commonFloor,
          floorMap: building.floorMap,
          floorIndex: {},
          zones,
          site: siteCode,
          sites: building.sites,
          fullName: building.fullName,
        }
        Object.values(building.floor).forEach(floor => {
          BuildingFloorZoneMap[building.code].floorIndex[floor] = getFloorIndex(building.code, floor)
        })
      }
      if (sites.length) {
        sites.forEach(site => {
          if (!Array.isArray(Sites[site.code])) {
            Sites[site.code] = []
          }
          Sites[site.code].push(building.code)
        })
      }
    })
  }
  return { BuildingFloorZoneMap, Buildings, Sites, Zones }
}

export async function getBuildingsWithUsers (id) {
  try {
    const response = await HTTP.get(`/buildings/${id}/users`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'building')
    throw err
  }
}

export async function createBuilding (request) {
  try {
    const response = await HTTP.post('/buildings', request)
    return response.data.data
  } catch (err) {
    const response = err.response
    if (response.status !== HttpStatus.CONFLICT) {
      notification.handleResponseError(err, 'building')
    }
    throw err
  }
}

export async function updateBuilding (id, request) {
  try {
    const response = await HTTP.put(`buildings/${id}`, request)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'building')
    throw err
  }
}

export async function updateBuildingUsers (request) {
  try {
    const response = await HTTP.post('/buildings/users', request)
    notification.handleResponseAlert(response)
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function getBuildingInfoById (id) {
  try {
    const response = await HTTP.get(`buildings/${id}`)
    return response.data.data
  } catch (err) {
    return err
  }
}

export async function getBuildingTemplateDetail (id, tid) {
  try {
    const response = await HTTP.get(`buildings/${id}/templates/${tid}`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'building.template')
    return err
  }
}

export async function updateBuildingTemplateDetail (id, tid, request) {
  try {
    const response = await HTTP.put(`/buildings/${id}/templates/${tid}`, request)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'building.template')
    return err
  }
}

export async function createOneBuildingTemplate (id, request) {
  try {
    const response = await HTTP.post(`/buildings/${id}/templates`, request)
    return response.data.data
  } catch (err) {
    return err
  }
}

export async function delOneTemplateFromBuilding (id, tid) {
  try {
    const response = await HTTP.delete(`/buildings/${id}/templates/${tid}`)
    return response.data.data
  } catch (err) {
    return err
  }
}

export async function delTemplatesFromBuilding (id, templateIds) {
  try {
    const response = await HTTP.delete(`/buildings/${id}/templates`, {data: templateIds})
    return response.data.data
  } catch (err) {
    return err
  }
}

export async function getBuildingByCode (code) {
  try {
    const response = await HTTP.get(`/buildings?code=${code}`)
    return response.data.data[0]
  } catch (err) {
    notification.handleResponseError(err, 'building')
    return null
  }
}

export async function getBuildingsUsers () {
  try {
    const response = await HTTP.get('/buildings/users')
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function getViewAllBuildingOpts () {
  try {
    const response = await HTTP.get('/buildings/view_all_options')
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}
